<h1 mat-dialog-title>{{ isEdit ? 'Nebenkosten-Artikel bearbeiten' : 'Nebenkosten-Artikel anlegen' }}</h1>
<div mat-dialog-content class="dialog-content">
    <mat-form-field appearance="outline" class="full">
        <mat-label>Bezeichnung</mat-label>
        <input matInput [formControl]="bezeichnungCtrl" required />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
        <mat-label>Kürzel</mat-label>
        <input matInput [formControl]="kuerzelCtrl" />
        <mat-hint>Optional – sonst aus Bezeichnung</mat-hint>
    </mat-form-field>

    <div class="row">
        <mat-form-field appearance="outline" class="half">
            <mat-label>Buchungskonto (Sachkonto)</mat-label>
            <input
                matInput
                [formControl]="buchungskontoCtrl"
                required
                placeholder="z.B. 4930"
                [matAutocomplete]="autoBuchung"
            />
            <mat-autocomplete #autoBuchung="matAutocomplete">
                <mat-option *ngFor="let opt of buchungskontoOptions" [value]="opt.konto_nr">
                    <span class="konto-nr">{{ opt.konto_nr }}</span>
                    <span class="konto-bez">{{ opt.bezeichnung }}</span>
                </mat-option>
            </mat-autocomplete>
            <mat-hint>Aufwandskonto aus dem Kontenrahmen</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline" class="half">
            <mat-label>Gegenkonto</mat-label>
            <input
                matInput
                [formControl]="buchungsgegenkontoCtrl"
                placeholder="z.B. 1600"
                [matAutocomplete]="autoGegen"
            />
            <mat-autocomplete #autoGegen="matAutocomplete">
                <mat-option *ngFor="let opt of gegenkontoOptions" [value]="opt.konto_nr">
                    <span class="konto-nr">{{ opt.konto_nr }}</span>
                    <span class="konto-bez">{{ opt.bezeichnung }}</span>
                </mat-option>
            </mat-autocomplete>
            <mat-hint>Default 1600</mat-hint>
        </mat-form-field>
    </div>

    <p class="hint">
        USt 19&nbsp;% – Match-Tags über „Tags bearbeiten“, weitere Details im Lager.
    </p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Abbrechen</button>
    <button mat-flat-button color="accent" type="button" [disabled]="!isValid() || saving" (click)="save()">
        {{ isEdit ? 'Speichern' : 'Anlegen' }}
    </button>
</div>
